<template>
  <div id="app">
    <ConfigProvider :locale="zhCN">
      <router-view></router-view>
    </ConfigProvider>
  </div>
</template>
<script setup lang="ts">
import { ConfigProvider } from 'ant-design-vue'
// @ts-ignore
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import '@/styles/index.less'
import { onMounted } from 'vue'
import { useAppStore } from './store/app'

const store = useAppStore()
onMounted(() => {
  store.getCurrentInfo()
})
</script>
